/** Barra de progreso con etiqueta y porcentaje (design.md §22.7). */
import { clsx } from 'clsx';

type ProgressTone = 'primary' | 'accent';

type ProgressBarProps = {
  label: string;
  value: number;
  tone?: ProgressTone;
  className?: string;
};

const fillStyles: Record<ProgressTone, string> = {
  primary: 'bg-primary',
  accent: 'bg-accent',
};

export function ProgressBar({ label, value, tone = 'primary', className }: ProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, Math.round(value)));

  return (
    <div className={clsx('w-full', className)}>
      <div className="mb-1.5 flex items-center justify-between gap-2">
        <span className="min-w-0 truncate text-xs font-medium text-text-secondary">{label}</span>
        <span className="shrink-0 text-xs font-semibold tabular-nums text-text-primary">
          {clamped}%
        </span>
      </div>
      <div
        role="progressbar"
        aria-label={label}
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
        className="h-2 w-full overflow-hidden rounded-full bg-bg-tertiary"
      >
        <div
          className={clsx('h-full rounded-full transition-all duration-300', fillStyles[tone])}
          style={{ width: `${clamped}%` }}
        />
      </div>
    </div>
  );
}
